import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RequestFilters} from "../models";

interface RequestFilterState {
  regularRequestFilters?: RequestFilters;
  subsequentRequestFilters?: RequestFilters;
}

const initialState: RequestFilterState = {
};

const requestFilterSlice = createSlice({
  name: "requestFilter",
  initialState: initialState,
  reducers: {
    updateRegularRequestFilters(state, action: PayloadAction<RequestFilters>) {
      state.regularRequestFilters = action.payload;
    },
    updateSubsequentRequestFilters(state, action: PayloadAction<RequestFilters>) {
      state.subsequentRequestFilters = action.payload;
    },
  },
});

export const { updateRegularRequestFilters: updateRegularRequestFilters, updateSubsequentRequestFilters: updateSubsequentRequestFilters} = requestFilterSlice.actions;

export default requestFilterSlice.reducer;
